import { render } from "./SearchAhead.vue?vue&type=template&id=ec277294&scoped=true"
import script from "./SearchAhead.vue?vue&type=script&lang=js"
export * from "./SearchAhead.vue?vue&type=script&lang=js"

import "./SearchAhead.vue?vue&type=style&index=0&id=ec277294&scoped=true&lang=css"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec277294"]])

export default __exports__